import React from 'react';

type InfoCardItem1Props = {
	iconClass: string;
	title: string;
	description: string;
	className?: string;
};

export default function InfoCardItem1({
	iconClass,
	title,
	description,
	className = '',
}: InfoCardItem1Props) {
	return (
		<div className={`info-card ${className}`}>
			<div className={`info-card-icon ${iconClass}`} />
			<div className="info-card-content">
				<div className="info-card-title">{title}</div>
				<div className="info-card-description">{description}</div>
			</div>
		</div>
	);
}
